import React from 'react'
import { useParams, Link, useLocation } from 'react-router-dom'
import articleContents from '../../mocks/articleContents.json'
import './article-detail.css'

const ArticleDetail = () => {
  const { slug } = useParams()
  const location = useLocation()
  const article = articleContents.articleContents.find(a => a.slug === slug)
  const searchParams = new URLSearchParams(location.search)
  const queryCategory = searchParams.get('category')
  const stateCategory = location.state?.fromCategory
  const categoryFromOrigin = stateCategory || queryCategory
  const backHref =
    categoryFromOrigin && categoryFromOrigin !== 'Todos'
      ? `/articulos?category=${encodeURIComponent(categoryFromOrigin)}`
      : '/articulos'

  if (!article) {
    return (
      <section className='article-detail article-detail__not-found'>
        <div className='article-detail__container'>
          <p className='p__main'>Artículo no encontrado</p>
        </div>
      </section>
    )
  }

  return (
    <section className='article-detail'>
      <div className='article-detail__container'>
        <Link to={backHref} className='article-detail__back-btn'>
          ← Volver a artículos
        </Link>

        <header className='article-detail__header'>
          <h1 className='article-detail__title'>{article.title}</h1>
          <div className='article-detail__meta'>
            <p className='article-detail__author'>Por {article.author}</p>
            <p className='article-detail__date'>
              Publicado: <time>{article.publicationDate}</time>
            </p>
            <p className='article-detail__source'>{article.source}</p>
          </div>
        </header>

        <article className='article-detail__content'>
          {article.content.map((block, index) => {
            switch (block.type) {
              case 'heading':
                return (
                  <h2 key={index} className='article-detail__heading'>
                    {block.text}
                  </h2>
                )
              case 'subheading':
                return (
                  <h3 key={index} className='article-detail__subheading'>
                    {block.text}
                  </h3>
                )
              case 'text':
                return (
                  <p key={index} className='article-detail__text'>
                    {block.text}
                  </p>
                )
              case 'quote':
                return (
                  <blockquote key={index} className='article-detail__quote'>
                    {block.text}
                  </blockquote>
                )
              case 'highlight':
                return (
                  <div key={index} className='article-detail__highlight'>
                    {block.text}
                  </div>
                )
              case 'note':
                return (
                  <p key={index} className='article-detail__note'>
                    {block.text}
                  </p>
                )
              case 'image': {
                const imageAsset = require(`../../${block.src}`)
                return (
                  <figure key={index} className='article-detail__figure'>
                    <img
                      src={imageAsset?.default || imageAsset}
                      alt={block.alt}
                      className='article-detail__image'
                    />
                    {block.caption && (
                      <figcaption className='article-detail__caption'>
                        {block.caption}
                      </figcaption>
                    )}
                  </figure>
                )
              }
              case 'references':
                return (
                  <ul key={index} className='article-detail__references'>
                    {block.items.map((item, i) => (
                      <li key={i}>
                        {item.text}{' '}
                        {item.url && (
                          <a href={item.url} target='_blank' rel='noreferrer'>
                            {item.url}
                          </a>
                        )}
                      </li>
                    ))}
                  </ul>
                )
              default:
                return null
            }
          })}
        </article>
      </div>
    </section>
  )
}

export default ArticleDetail
